import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/general/Login.vue';
import Spaces from './views/general/Spaces.vue';
import Entities from './views/editor/Entities.vue';
import Contents from './views/editor/Contents.vue';
import Content from './views/editor/Content.vue';
import Media from './views/editor/Media.vue';
import AdminEntities from './views/admin/Entities.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login,
    },
    {
      path: '/spaces',
      name: 'spaces',
      component: Spaces,
      meta: { requiresAuth: true },
    },
    {
      path: '/editor/spaces/:spaceId/entities',
      name: 'editor-entities',
      component: Entities,
      meta: { requiresAuth: true },
    },
    {
      path: '/editor/spaces/:spaceId/entities/:entityId/contents',
      name: 'editor-contents',
      component: Contents,
      meta: { requiresAuth: true },
    },
    {
      path: '/editor/spaces/:spaceId/entities/:entityId/contents/:contentId/versions/:versionId',
      name: 'editor-content',
      component: Content,
      meta: { requiresAuth: true },
    },
    {
      path: '/editor/spaces/:spaceId/entities/:entityId/create-content',
      name: 'editor-content-create',
      component: Content,
      meta: { requiresAuth: true },
    },
    {
      path: '/editor/spaces/:spaceId/media/:page',
      name: 'editor-media',
      component: Media,
      meta: { requiresAuth: true },
    },
    {
      path: '/admin/spaces/:spaceId/entities',
      name: 'admin-entities',
      component: AdminEntities,
      meta: { requiresAuth: true },
    },
    { path: '/', redirect: '/login' },
  ],
});
